export default __webpack_public_path__ + "static/_borrow-mockup-desktop 1-057299044abb98ce853722281bd97d72.png";